import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '1fr',
    justifyContent: 'flex-start',
    columnGap: theme.spacing(24),
    rowGap: theme.spacing(16),

    paddingInline: theme.spacing(16),
    paddingBottom: theme.spacing(16),
    paddingTop: theme.spacing(8),

    min768: {
        gridTemplateColumns: 'repeat(3, minmax(auto, 225px))',
        paddingInline: theme.spacing(40),
    },

    min1024: {
        paddingTop: 0,
        paddingInline: theme.spacing(40),
        paddingBottom: theme.spacing(20),
    },
});

export const collapse: TRuleWithTheme = () => ({
    display: 'grid',
    gridTemplateRows: '0fr',
    transition: 'grid-template-rows 0.3s ease-in-out',

    min768: {
        gridTemplateRows: '1fr',
    },
});

export const collapseExpanded: TRuleWithTheme = () => ({
    gridTemplateRows: '1fr',
});

export const collapseInner: TRuleWithTheme = () => ({
    minHeight: 0,
});

export const collapseInnerClipped: TRuleWithTheme = () => ({
    overflow: 'hidden',

    min768: {
        overflow: 'visible',
    },
});

export const toggle: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),

    padding: `${theme.spacing(8)} ${theme.spacing(16)} ${theme.spacing(16)}`,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',

    ...theme.typography.ParagraphSmallMedium,
    fontWeight: 500,
    color: theme.colors.black,

    min768: {
        display: 'none',
    },
});

export const dot: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.colors.accentSecondary,
});

export const toggleCaret: TRuleWithTheme = () => ({
    transform: 'scale(1, 1)',
    transition: 'all 0.3s ease-in-out',
});

export const toggleCaretOpen: TRuleWithTheme = combineRules(toggleCaret, ({ theme }) => ({
    transform: 'scale(1, -1)',
    color: theme.colors.accentSecondary,
}));
